import React from 'react';
import './Loader.css';

const Loader = ({ label = 'Loading...', size = 'md' }) => (
  <div className={`loader loader-${size}`} role="status" aria-live="polite">
    <div className="loader-spinner" aria-hidden="true">
      <span className="loader-ring" />
      <span className="loader-dot" />
    </div>
    <p className="loader-text">{label}</p>
  </div>
);

export default Loader;
